/**
 * Etapa 3 — Outros (mockup 20 Estado C, bloco "Outros").
 *
 * Horas + GLP + 2 resíduos (sliders). Layout alinhado com mockup screen 20.
 */
import type { EventosOrgInputs } from '../api/types';
import { t, type I18nBundle } from '../lib/i18n';
import { NavRow, QBlock } from './QBlock';
import { Slider } from './Slider';

interface Props {
  value: EventosOrgInputs;
  onChange: (patch: Partial<EventosOrgInputs>) => void;
  onBack: () => void;
  onNext: () => void;
  i18n: I18nBundle;
}

export function StepOrgOutros({ value, onChange, onBack, onNext, i18n }: Props) {
  return (
    <form
      onSubmit={(e) => {
        e.preventDefault();
        onNext();
      }}
      className="flex flex-col gap-4"
    >
      <QBlock title={t(i18n, 'org.step3.title')}>
        <Slider
          label={t(i18n, 'org.step3.duration_hours')}
          hint={t(i18n, 'org.step3.duration_hours_hint')}
          value={value.duration_hours}
          onChange={(v) => onChange({ duration_hours: v })}
          min={0}
          max={168}
          step={0.5}
          unit={t(i18n, 'org.units.hours')}
        />
        <Slider
          label={t(i18n, 'org.step3.glp_kg')}
          value={value.glp_kg}
          onChange={(v) => onChange({ glp_kg: v })}
          min={0}
          max={2000}
          step={1}
          unit={t(i18n, 'org.units.kg')}
        />
        <Slider
          label={t(i18n, 'org.step3.waste_organic_kg')}
          value={value.waste_organic_kg}
          onChange={(v) => onChange({ waste_organic_kg: v })}
          min={0}
          max={5000}
          step={1}
          unit={t(i18n, 'org.units.kg')}
        />
        <Slider
          label={t(i18n, 'org.step3.waste_recyclable_kg')}
          value={value.waste_recyclable_kg}
          onChange={(v) => onChange({ waste_recyclable_kg: v })}
          min={0}
          max={5000}
          step={1}
          unit={t(i18n, 'org.units.kg')}
        />
      </QBlock>

      <NavRow
        nextIsSubmit
        onBack={onBack}
        backLabel={t(i18n, 'org.common.back')}
        nextLabel={t(i18n, 'org.common.next')}
      />
    </form>
  );
}
